var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboardPieChart"},[_c('ApexChart',{attrs:{"type":"pie","series":_vm.series,"options":_vm.options,"width":_vm.width,"height":_vm.height}}),(_vm.label)?_c('p',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }